import { createAction } from '@reduxjs/toolkit';
import {
  FETCH_USER_REQUEST,
  CREATE_USER_REQUEST,
  UPDATE_USER_REQUEST,
  DELETE_USER_REQUEST,
  FETCH_USER_DETAILS_REQUEST,
  FETCH_AWARD_USER_REQUEST,
  FETCH_LUCKY_DRAW_USER_REQUEST,
  RESET_USER_STATE,
  GET_PRODUCT_LIST_REQUEST,
  UPDATE_PVS_DATA_SUCCESS,
  PAYMENT_SUCCESS,
} from '../types/user';

// Fetch Categories
export const fetchUsers = (userData) => ({
  type: FETCH_USER_REQUEST,
  payload: userData,
});
export const fetchUserDetails = (userData) => ({
  type: FETCH_USER_DETAILS_REQUEST,
  payload: userData,
});

// Create User
export const createUser = ( userData) => ({
  type: CREATE_USER_REQUEST,
  payload:  userData ,
});

// Update User
export const updateUser = (userData, token) => ({
  type: UPDATE_USER_REQUEST,
  payload: { userData, token },
})

// Get product list
export const getProductList = (pageData,token) => ({
  type: GET_PRODUCT_LIST_REQUEST,
  payload: {pageData,token},
})

// Delete User
export const deleteUser = (userId) => ({
  type: DELETE_USER_REQUEST,
  payload: userId,
});

// Awards User
export const getAwardUser = () => ({
  type: FETCH_AWARD_USER_REQUEST,
  payload: {},
});

// Lucky Draw User
export const getLuckyDrawUser = () => ({
  type: FETCH_LUCKY_DRAW_USER_REQUEST,
  payload: {},
});

// Reset State
export const resetUserState = () => ({
  type: RESET_USER_STATE,
});

export const updatePvsData = (data, token) => ({
  type: UPDATE_PVS_DATA_SUCCESS,
  payload: {data, token},
});

export const paymentSuccess = (data, token) => ({
  type: PAYMENT_SUCCESS,
  payload: {data, token},
});
